<template>
  <div class="orderAi">
    <div class="headers">
      <span class="iconfont icon-back-left" @click="goBack" style="position: absolute;left: 20px"></span>
      <span>{{ lang.qqdd }}</span>
    </div>
    <div class="menuss">
      <div :class="['menu',orderStatus == 0 ?  'menu-active':'']" @click="selectMenu(0)">{{ lang.zc }}</div>
      <div :class="['menu',orderStatus == 1 ?  'menu-active':'']" @click="selectMenu(1)">{{ lang.yjs }}</div>
    </div>
    <div class="bodyoo">
      <div class="items">
        <van-list v-model="loading" :finished="finished" :finished-text="lang.mygdl" :loading-text="lang.jzz" @load="onLoad">
          <div class="new-features" v-for="item in recordList">
            <div class="title" v-if="item.type == 1">{{item.coinName}}/USDT</div>
            <div class="title" v-else>{{item.coinName}}</div>
            <div class="line">
              <div class="left">{{ lang.fx }}</div>
              <div class="right green " v-if="item.selected == 0">{{ lang.sheng }}</div>
              <div class="right red" v-else-if="item.selected == 1">{{lang.jiang}}</div>
            </div>
            <div class="line">
              <div class="left">{{lang.bzj}}</div>
              <div class="right">$ {{item.bzj}}</div>
            </div>
            <div class="line">
              <div class="left">{{lang.gangg}}</div>
              <div class="right">{{item.progressWidth}} X</div>
            </div>
            <div class="line">
              <div class="left">{{lang.shous }}</div>
              <div class="right">{{item.hyNum}}</div>
            </div>
            <div class="line">
              <div class="left">{{ lang.newamt }}</div>
              <div class="right">{{ (item.price).toFixed(1) }}</div>
            </div>
            <div class="line">
              <div class="left">{{ lang.jsamt }}</div>
              <div :class="['right',item.selected == 0 ? 'green':'red']" v-if="orderStatus == 0">{{ (item.localPrice).toFixed(1) }}</div>
              <div :class="['right',item.selected == 0 ? 'green':'red']" v-else>{{ (item.priceJs).toFixed(1) }}</div>
            </div>
            <div class="line">
              <div class="left">{{ lang.dianshu }}</div>
              <div class="right">{{item.pips}}</div>
            </div>
            <div class="line">
              <div class="left">{{ lang.chengb }}</div>
              <div class="right">${{item.feeAmt}}</div>
            </div>
            <div class="line" v-if="orderStatus == 0">
              <div class="left">{{ lang.profit }}</div>
              <div class="right" v-if="item.bonus >=0">+${{ item.bonus }}</div>
              <div class="right" v-else>-${{ -item.bonus }}</div>
            </div>
            <div class="line" v-else>
              <div class="left">{{ lang.profit }}</div>
              <div class="right" v-if="item.status == 3">+${{ item.bonus }}</div>
              <div class="right" v-else>-${{ item.bonus }}</div>
            </div>
            <div class="line">
              <div class="left">{{lang.newtime}}</div>
              <div class="right">{{ item.ctime }}</div>
            </div>
            <div class="confirm-button" v-if="orderStatus == 0" @click="jiesuan(item)">{{ lang.pingc }}</div>
        </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { CONF } from '@/assets/js/config'
  import {
    mapState
  } from 'vuex'
  export default {
    data() {
      return {
        page: 1,
        totalNum: 0,
        orderStatus: 0,
        recordList: [],
        timer: '',
        loading: false,
        finished: false,
      }
    },
    activated() {
      this.page = 1
      this.recordList = []
      this.finished = false
    },
    beforeDestroy(){
      clearInterval(this.timer);
      this.timer = null;
    },
    computed: {
      ...mapState(['userInfo', 'lang']),
      winOrLost() {
        // //涨
        // if(item.selected == 0 && item.price > item.localPrice){
        //   return item.amt * item.odd / 100
        // }else if(item.selected == 1 && item.price < item.localPrice){
        //   return item.amt * item.odd / 100
        // }
        return 0
      }
    },
    methods: {
      goBack() {
        this.$router.push("/")
      },
      onLoad() {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        setTimeout(() => {
          this.getRecord()
        }, 1000);
      },
      getRecord(){
        this.$xhrGet('/product/orderHy',{ page: this.page, status:this.orderStatus}).then(res => {
          this.loading = false;
          this.recordList = res.data
          this.totalNum =  res.totalNum;
          // 数据全部加载完成
          if (this.recordList.length >= this.totalNum) {
            this.finished = true;
          }
          if(this.orderStatus == 0 && this.totalNum >0){
            clearInterval(this.timer)
            this.timer = setInterval(()=>{
              this.getRecord();
            },1e3)
          }else {
            clearInterval(this.timer)
          }
        })
      },
      jiesuan(item){
        this.$xhrGet('/product/jiesuanHy',{ ordno: item.ordno}).then(res => {
          if (res.err == 0) {
            this.$message({message: '',  type: 'success'});
            this.getRecord()
          }else{
            this.$message({message: res.msg,  type: 'error'});
          }
        })
      },
      selectMenu(index){
        if (this.orderStatus == index){return}
        this.orderStatus = index
        this.page = 1
        this.recordList = []
        this.finished = false
        clearInterval(this.timer)
      },
    }
  }
</script>
<style type="text/css"  scoped>
.orderAi{
  background: #000;
  height: 100vh;
  color: #fff;
}
.headers{
  font-size: 0.53333rem;
  font-weight: 600;
  display: flex;
  padding: 0.53333rem;
  justify-content: center;
  align-items: center;
}
.bodyoo{
  margin:0 20px;
  height: 80%;
  overflow: auto;
}
.new-features{
  padding: 20px;
  background: #1a1a1a;
  border-radius: 20px;
  margin-bottom: 20px;
  position: relative;
}
.new-features:before {
  content: "";
  display: inline-block;
  background: #c2e22a;
  border-radius: 5px;
  width: 5px;
  height:24px;
  top: 20px;
  left: 0;
  position: absolute;
}
.new-features .title{
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 25px;
}
.new-features .line{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.new-features .line .left {
  opacity: .3;
}
.menuss {
  margin-bottom: 15px;
  display: flex;
  justify-content: flex-start;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff4d;
}
.menuss .menu-active {
  background: #1a1a1a;
  color: #fff;
}
.menuss .menu {
  padding: 10px 17px;
  border-radius: 19px;
}

.red{
  color:#ce7735
}
.green{
  color:green;
}
.confirm-button {
  font-weight: 600;
  font-size: 16px;
  color: #000;
  height: 44px;
  background: #c0dd2b;
  border-radius: 13px;
  text-align: center;
  line-height: 44px;
  margin-top: 24px;
}

</style>